<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Electrical Engineering"
                   :links="[{title:'Home', url:'/'},{title:'Faculty'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="4"></sidebar>
        </section>
        <section class="content">
            <div class="heading-black1">Faculty</div>
            <faculty-card class="mb-5"
                          v-for="(faculty, index) in facultyList"
                          :key="index"
                          :faculty="faculty"
                          :dir="dirName"></faculty-card>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/electrical/Sidebar";
import FacultyCard from "@/components/FacultyCard";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "Faculty",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    FacultyCard,
    KeyRecruiters,
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      dirName: 'electrical',
      facultyList: [
        {
          name: 'Dr. Tapre Pawan C.',
          cv: 'test.pdf',
          image: 'dr_tapre_p_c',
          designation: ' Head &  Associate Professor) ',
          qualification: 'BE (Electrical), ME( Power System ) Ph.D. (Electrical)',
          experience: '25 Years ( Teaching 17 yrs Industries 8 years',
          specialization: ' Power System',
          contact: '7987331104',
          email: 'pawan.tapre25snd@gmail.com '
        },
        {
          name: 'Prof. Bhangale H.K.',
          cv: 'test.pdf',
          image: 'bhangale_h_k',
          designation: ' Assistant Professor',
          qualification: 'M. E. (Digital Techniques & Instrumentation)',
          specialization: ' Digital Techniques & Instrumentation',
          experience: ' 24 years ( Teaching 21 years Industrial 3 years)',
          contact: '9588400365',
          email: ' bhangaleharish@rediffmail.com'
        },
        {
          name: 'Prof. Solanki A.M.',
          cv: 'test.pdf',
          image: 'solanki_a_m',
          designation: ' Assistant Professor',
          qualification: 'M. E. (Power Electronics)',
          specialization: ' Power Electronics',
          experience: '12 Years',
          contact: '9893577098',
          email: 'amitpower.elex@gmail.com'
        },
        {
          name: 'Prof. Subhan M.A.',
          cv: 'test.pdf',
          image: 'employee_placeholder_male',
          designation: '  Assistant Professor',
          qualification: 'M. E. (Communication)',
          specialization: ' Microcontroller, Analog  & Digital Electronics',
          experience: '12 Years',
          contact: '9970069018',
          email: 'msubhan24@gmail.com'
        },
        {
          name: 'Prof. Rajnor D. L.',
          cv: 'test.pdf',
          image: 'rajnor_d_',
          designation: ' Assistant Professor',
          qualification: 'M. E. (Communication)',
          specialization: ' Microcontroller, Analog & Digital Electronics, Control System',
          experience: '13 Years',
          contact: '9960940514',
          email: 'deepakrajnor@gmail.com'
        },
        {
          name: 'Prof. Hadole A. V.',
          cv: 'test.pdf',
          image: 'hadole_a_v',
          designation: ' Assistant Professor',
          qualification: 'M. E. Electrical (Power System)',
          specialization: ' PLC & SCADA',
          experience: '09 Years',
          contact: '9503488649',
          email: 'hadole.avinash@gmail.com'
        },
        {
          name: 'Prof. Khemnar K. N.',
          cv: 'test.pdf',
          image: 'employee_placeholder_male',
          designation: ' Assistant Professor',
          qualification: 'M. E. (Power System)',
          specialization: ' Power System ',
          experience: '06 Years',
          contact: '9975188023',
          email: 'khemnarkalpana@gmail.com'
        },
        {
          name: 'Prof. Shejwal C. K.',
          cv: 'test.pdf',
          image: 'shejwal_c_k',
          designation: ' Assistant Professor',
          qualification: 'M. E. (Power System)',
          specialization: ' Power System ',
          experience: '03 Years (Teaching 2 years Industrial 1 year)',
          contact: '8600618134',
          email: 'chandrkant.cs77@gmail.com'
        },
        {
          name: ' Prof. Mutha N.D.',
          cv: 'test.pdf',
          image: 'mutha_n_d',
          designation: ' Assistant Professor',
          qualification: 'M. E. (Power System)',
          specialization: ' Power System ',
          experience: '4 Years (Teaching 2 years Industrial 2 years)',
          contact: '9022893078',
          email: 'nikhil769@gmail.com'
        },
        {
          name: 'Prof. Choube S. H.',
          cv: 'test.pdf',
          image: 'chaobe',
          designation: ' Assistant Professor',
          qualification: 'B. E. (Electrical Engineering), M.E.* (Power System)',
          specialization: ' Electrical Machine',
          experience: '24 Years',
          contact: '9923069001',
          email: ' shyamchoube@gmail.com'
        },
        {
          name: 'Mr. Jadhav K. K.',
          cv: 'test.pdf',
          image: 'jadhav_k_k',
          designation: ' Lab Assistant',
          qualification: 'Diploma in Electronics Engineering',
          experience: '13 Years',
          specialization: 'none',
          contact: '9834171336',
          email: 'kunalj.04@gmail.com'
        },
        {
          name: 'Mr.Tribhuwan S. B.',
          cv: 'test.pdf',
          image: 'employee_placeholder_male',
          designation: ' Lab Assistant',
          qualification: 'Diploma in Electrical Engineering',
          experience: '13 Years',
          specialization: 'none',
          contact: '9890043848',
          email: 'sandiptribhuvan674@gmail.com'
        },
        {
          name: 'Mr. Bhatude R. A.',
          cv: 'test.pdf',
          image: 'bhatude_r_a',
          designation: ' Lab Assistant',
          qualification: 'Diploma in Electrical Engineering',
          experience: '0.6 Years',
          specialization: 'none',
          contact: '9325996674',
          email: 'rahulbhatude2000@gmail.com'
        },
        {
          name: 'Mr. Gade M. S.',
          cv: 'test.pdf',
          image: 'employee_placeholder_male',
          designation: ' Peon',
          qualification: 'H.S.C',
          experience: '11 Years',
          specialization: 'none',
          contact: '9960680969',
          email: 'likida0321@gmail.com'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped/>
